import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import marchPromo2026Image from 'img/marchPromo2026/sidebarBannerImage.png';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { sendDwh } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';

import styles from './MarchPromo2026SidebarBanner.css';

const PROMO_ID = 'march-promo-2026';

export const MarchPromo2026SidebarBanner = () => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);

    useEffect(() => {
        sendDwh({ eventCategory: 'banner', action: 'view', dwh_enabled: true, dwhData: { name: PROMO_ID } });
    }, []);

    const onClick = useCallback(() => {
        sendDwh({ eventCategory: 'banner', action: 'click', dwh_enabled: true, dwhData: { name: PROMO_ID } });
        opener(
            '/promo/quota?action=request-payment&productId=W1TB_1y_ogogoblako_force_trial&utm_source=cloud_home_page&utm_medium=promo_button_plus1tb&utm_campaign=cloud_mkt_flight_coverage_campaign_0326&mt_link_id=axsxd5',
            true
        );
    }, []);

    return (
        <div className={classNames(styles.root, { [styles.darkRoot]: isDarkTheme })} onClick={onClick}>
            <Text className={styles.text}>+1 ТБ на 3 месяца бесплатно</Text>
            <img className={styles.image} src={marchPromo2026Image} alt="Ого-го Облако" />
        </div>
    );
};
